import { ApplicationConfig } from '@config/application.config';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin/internals';

export default {
  namespace: ApplicationConfig.applicationName,
  keys: [
    'auth.token',
    'auth.loggedUser',
    'application.language'
  ]
} as NgxsStoragePluginOptions;
